import { useEffect, useRef, useCallback } from "react";

export default function useIdleTimer(onIdle, timeout = 45 * 60 * 1000) {
  const timerRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  const resetTimer = useCallback(() => {
    const now = Date.now();

    // throttle: evita reset en cada pixel del mouse
    if (now - lastActivityRef.current < 300) return;

    lastActivityRef.current = now;

    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      onIdle?.();
    }, timeout);
  }, [timeout, onIdle]);

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "visibilitychange",
    ];

    const handleActivity = () => {
      if (document.visibilityState !== "hidden") resetTimer();
    };

    events.forEach((e) => window.addEventListener(e, handleActivity));
    resetTimer();

    return () => {
      events.forEach((e) => window.removeEventListener(e, handleActivity));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer]);
}
